enum FrameTypeLastDays {
  LastSevenDays = 0,
  LastThirtyDays = 1,
}

export default FrameTypeLastDays;
